import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { MobileTabNavigation } from '@/widgets/mobile-tab-navigation';

const UserLayout = () => {
  return (
    <>
      <Outlet />
      <MobileTabNavigation />
    </>
  );
};

export const Route = createFileRoute('/_user')({
  component: UserLayout,
});
